import React, {useRef, useState} from "react";
import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import {
  getErrorMessageByKey,
  useNotification,
  Modal,
  useObject, Input, formatBytes, jsonFormatText,
} from "@vokymlak/kabinet-ui";

function ModalAddAuthorizeCode(props) {
  const inputToken = useRef(null);

  const {notification} = useNotification();

  const changeAdd = (event) => {
    event.preventDefault();

    const token = jsonFormatText(inputToken.current.value);

    if (!token || (!!token && token.length === 0)) {
      notification("Код авторизации", "red");
      return;
    }

    const jsonData = JSON.stringify({
      authorize_code: token,
    });

    axios
      .post("/api/alfabank/add/authorize-code", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Код авторизации добавлен", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    <Modal handleClose={() => props.handleClose()}>
      <form className="Form" onSubmit={(event) => changeAdd(event)}>
        <div className="Form__title">
          6.
          <div className="Text__signature">Вводим временный код после авторизации (code)</div>
        </div>

        <div className="Form__field Form__field_last">
          <Input reference={inputToken} label="authorizeCode *"/>
        </div>

        <div className="Form__actions Form__actions_center">
          <button className="Action__button Action__button_all Action__button_blue">
            Сохранить
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default ModalAddAuthorizeCode;
